import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'nomPrenom'
})
export class NomPrenomPipeMock implements PipeTransform {

	transform(value: any): any {
		return value;
	}

}
